module.exports = __webpack_public_path__ + "static/banner-881df26680ce5eafa3c5b21cf1fbdab8.png";